import { AdminOnlyItemRestraints } from '@core/shared/restraints';
export class HealthInsuranceRestraints extends AdminOnlyItemRestraints {}